export default __webpack_public_path__ + "static/media/VID-20220612-WA0003.c177c261.mp4";